export class QueryBuilderV2 {
  private conditions = new Map<string, string>();

  /**
   * Add or update a condition in the query.
   * @param identifier - A unique identifier for the condition (e.g., "companyFilter")
   * @param condition - SQL condition as a string (e.g., "Company_Name = 'My Company'")
   */
  addOrUpdateCondition(identifier: string, condition: string) {
    this.conditions.set(identifier, condition);
  }

  /**
   * Remove a condition from the query by its identifier.
   * @param identifier - The unique identifier for the condition
   */
  removeCondition(identifier: string) {
    this.conditions.delete(identifier);
  }

  /**
   * Clear all conditions.
   */
  clearConditions() {
    this.conditions.clear();
  }

  /**
   * Generate the final SQL WHERE clause.
   * @returns A string representing the SQL WHERE clause.
   */
  getQuery(): string {
    const conditionsArray = Array.from(this.conditions.values());
    return conditionsArray.length > 0 ? conditionsArray.join(' AND ') : '1=1';
  }
}
